module.exports = __webpack_public_path__ + "img/scrum.a5c44d83.png";